<template>
  <v-row v-if="course">
    <!-- Partie header de la colonne des videos du parcours -->
    <v-col sm="12" class="py-0">
      <div>
        <v-card-actions @click="show = !show" class="pl-0">
          <!-- <v-btn color="pink lighten-2" text> Description </v-btn> -->
          <v-btn
            rounded
            outlined
            color="#bbbbc8"
            height="20px"
            style="opacity: 0.8"
            dark
            class="px-2"
            >{{$t('common.detail')}}</v-btn
          >
          <!-- <v-spacer></v-spacer> -->

          <v-btn icon height="20px" width="20px">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <div v-show="show">
            <v-card-text class="py-0 pl-2">
              <div>
                {{ course.description }}
              </div>
            </v-card-text>
          </div>
        </v-expand-transition>

        <v-divider></v-divider>
      </div>
    </v-col>

    <v-col sm="12" style="height: 575px" class="col overflow-y-auto py-0">
      <video-card
          v-for="v in course.videos"
          :key="v.id"
          :video="v"
          :router-link-to="{ name: 'videoFromCourse', params: { id: v.id, idParcours: course.id } }"
          layout="horizontal"
          :active="v.id === video.id"
      ></video-card>
    </v-col>
  </v-row>
</template>

<script>
import VideoCard from "../video/videoCard";

export default {
  name: "courseItemVertical",
  components: { VideoCard },
  data: () => ({
    show: false,
  }),
  props: {
    course: Object,
    video: Object,
  },
};
</script>



